import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入echart
// import * as echarts from "echarts";
// 安装element ui 插件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/iconfont.css';
// 引入crypto-js
import CryptoJS from "crypto-js";

// 导入封装的网络请求js文件,供所有组件使用 
// import netWork from './api/netWorkRequest'
// Vue.prototype.$request = netWork;//($request (key))
// 导入url.js
import urls from './api/url'
//导入全局的axios以及vue-axios网络请求
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.prototype.$url = urls;//公共的url接口部分,供所有组件访问
Vue.use(VueAxios,axios);
Vue.config.productionTip = false
Vue.use(CryptoJS);
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
